import { useDeleteProduct } from 'api/services/productsService';
import { GenericDeleteModal } from 'components/ui/GenericDeleteModal';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { useUI } from 'contexts/UiContext';
import { useTranslation } from 'react-i18next';

interface DeleteProductModalProps {
  open: boolean;
  onCancel: () => void;
  productId?: string;
}

export const DeleteProductModal = ({
  open,
  onCancel,
  productId,
}: DeleteProductModalProps) => {
  const { t } = useTranslation();
  const { selectedCompany } = useUI();
  const { mutateAsync: deleteProductModal, isPending: isPendingDeleteProduct } =
    useDeleteProduct();
  const { openNotification } = useFloatNotification();

  const handleConfirm = () => {
    deleteProductModal({
      productId: productId || '',
      companyId: selectedCompany || '',
    })
      .then(() => {
        openNotification(
          t('success'),
          t('product.delete-product-modal.succes-deleted'),
          'success'
        );
      })
      .catch(() =>
        openNotification(
          t('error'),
          t('product.delete-product-modal.error-deleted'),
          'error'
        )
      );

    onCancel();
  };

  return (
    <GenericDeleteModal
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      confirmLoading={isPendingDeleteProduct}
      bodyText={t('product.delete-product-modal.delete-text')}
    />
  );
};
